export default "__VITE_ASSET__rP1rGPQT__"